export enum ClauseInstructionKind {
  ADD_CLAUSES = 'addClauses',
  REMOVE_CLAUSES = 'removeClauses',
  UPDATE_CLAUSE = 'updateClause',
  ADD_VALUES_TO_CLAUSE = 'addValuesToClause',
  REMOVE_VALUES_FROM_CLAUSE = 'removeValuesFromClause',
}
